import React, {useEffect} from 'react'
import SEDocumentoTributario from './Components/ResumenFactura/CREDocumentoTributario'
import {useSelector} from 'react-redux'
import {State} from '../../reducers'
import {useHistory} from 'react-router'
import CREEncabezado from './Components/CREEncabezado'
import CREModalsResumenControl from './Components/ResumenFactura/Modals/CREModalsResumenControl'
import CREFooterResumen from './Components/ResumenFactura/CREFooterResumen'
import CREFooterFinalizacion from './Components/ResumenFactura/CREFooterFinalizacion'

const ResumenFacturaComprobanteRetencion = () => {
  const history = useHistory()
  const facturaEmitida = useSelector((state: State) => state.comprobanteRetencion.facturaEmitda)
  const documentos = useSelector((state: State) => state.comprobanteRetencion.documentosAsociados)

  useEffect(() => {
    if (documentos.length === 0) history.push('/otros-documentos/comprobante-retencion/formulario')
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      <CREModalsResumenControl />
      <CREEncabezado url='/otros-documentos/comprobante-retencion/formulario' />
      <div id='w-node-_5c6af4dc-0d52-341f-2ef6-a52695e59ec5-0b1e6fa6' className='w-layout-layout bill-section wf-layout-layout'>
        <div id='w-node-_5c6af4dc-0d52-341f-2ef6-a52695e59ed4-0b1e6fa6' className='w-layout-cell' style={{minHeight: '100vh'}}>
          <div className='card'><SEDocumentoTributario /></div>
        </div>
        {!facturaEmitida ? <CREFooterResumen /> : <CREFooterFinalizacion />}
      </div>
    </>
  )
}

export default ResumenFacturaComprobanteRetencion
